import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_privacy')({
  component: PrivacyLayout,
});

function PrivacyLayout() {
  return <Outlet />;
}
